<template>
  <div>
    <v-card-title>
      <v-spacer></v-spacer>

      <v-col cols="12" sm="6" md="4">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="search"
              label="Picker in menu"
              prepend-icon="mdi-magnify"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            :first-day-of-week="1"
            v-model="search"
            no-title
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(search)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-card-title>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Uploaded Date
            </th>
            <th>
              &nbsp;&nbsp;&nbsp;&nbsp; Work
            </th>
            <th v-if="$route.params.id">
              &nbsp;&nbsp;&nbsp;&nbsp; Upload Checked File
            </th>
            <th>
              File Type
            </th>
            <th class="text-left">
              Tutor
            </th>
            <th class="text-left">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, ind) in items">
            <tr v-for="(data, index) in item" :key="index">
              <td>
                {{ formatDate(ind) }}
              </td>
              <td v-if="$route.params.id">
                <p class="py-4" v-for="(name, index) in data" :key="index">
                  <v-btn
                    small
                    text
                    color="primary"
                    :href="`${getBaseURL}/storage/${name.work_image}`"
                    dark
                    target="_blank"
                  >
                    View
                  </v-btn>
                </p>
              </td>
              <td v-else>
                <p class="py-5" v-for="(name, index) in data" :key="index">
                  <a
                    :href="`${getBaseURL}/storage/${name.work_image}`"
                    target="_blank"
                    >view</a
                  >
                </p>
              </td>
              <td v-if="$route.params.id">
                  <div v-for="(name, index) in data" :key="index">
                    
                      <p v-if="name.file_type != 'application/pdf'">
                        <v-btn
                          small
                          text
                          color="primary"
                          dark
                          class="font-weight-bold mt-2 py-7"
                        >
                          Only Document Upload
                        </v-btn>
                      </p>

                    <v-file-input
                      v-model="form_data.work_file[index]"
                      accept="application/pdf, image/png, image/jpeg"
                      full-width=false
                      flat 
                      solo
                      @change="uploadImage(name.id , index)"  :class="name.file_type == 'application/pdf' ? '' : 'd-none'"
                      >
                      </v-file-input>
                  </div>
              </td>
              <td>
                <p class="py-5" v-for="(name, index) in data" :key="index">
                  <span v-if="name.file_type != null">
                    {{ name.file_type }}
                  </span>
                </p>
              </td>
              <td>
                <p class="py-5" v-for="(name, index) in data" :key="index">
                  <span v-if="name.tutor != null"
                    >{{ name.tutor.tutor_fname }}
                    {{ name.tutor.tutor_lname }}</span
                  >
                </p>
              </td>
              <td v-if="$route.params.id">
                <p class="py-4" v-for="(name, index) in data" :key="index">
                  <v-btn
                    class="pending"
                    v-if="name.status == '0'"
                    :value="name.id"
                    small
                    @click="changeStatus(name)"
                  >
                    Pending
                  </v-btn>
                  <v-btn
                    v-else
                    class="checked"
                    :value="name.id"
                    @click="changeStatus(name)"
                  >
                    Checked
                  </v-btn>
                </p>
              
              </td>
              <td v-else>
                <p class="py-5" v-for="(name, index) in data" :key="index">
                  <span v-if="name.status == '1'">Checked</span>
                  <span v-else>Pending</span>
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>

    <!-- image editor -->

    <v-overlay :value="overlay" style="z-index: 99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="dialog" fullscreen>
      <v-card>
        <imageEditor :id="id" :image="image"></imageEditor>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" top right color="success" v-if="snackbar">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
          >X</v-btn
        >
      </template>
    </v-snackbar>

  </div>
</template>

<script>
import { bus } from "../../main";
import DataTableMixin from "../../mixins/dataTable";
import Form from "../../utils/form";
import imageEditor from "./imageEditor.vue";

export default {
  name: "previousWork",
  components: {
    imageEditor,
  },
  props: ["getdata"],
  mixins: [DataTableMixin],
  data() {
    return {
      id: "",
      image: "",
      search: "",
      snackbarMessage: "",
      snackbar: false,
      menu: false,
      url: process.env.VUE_APP_BASE_URL,
      overlay: false,
      errors: {},
      dialog: false,
      loading: true,
      url: process.env.VUE_APP_BASE_URL,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      form_data: {
        workImage: "",
        tutor_id: "",
        work_file: {},
        fileType: null,
      },
    };
  },
  watch: {
    search(val) {
      if (this.$route.params.id) {
        this.searchGetItems(val);
      } else {
        this.searchGetStudentData(val);
      }
    },
  },
  computed: {
    getBaseURL() {
      return window.baseURL;
    },
  },
  methods: {
    closeDialog() {
      this.open = false;
      // this.loading = true;
      this.dialog = false;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("-");
    },

    searchGetItems(val) {
      axios
        .post(apiRoutes.UploadWork.getData, {
          search: val,
          id: this.$route.params.id,
        })
        .then((response) => {
          this.items = response.data.response;

          this.loading = false;
        });
    },
    searchGetStudentData(val) {
      axios
        .post(apiRoutes.UploadWork.getStudentData, { search: val })
        .then((response) => {
          this.items = response.data.response;

          this.loading = false;
        });
    },
    openDialog(item) {
      this.dialog = true;
      this.image = `${this.getBaseURL}/storage/${item.work_image}`;
      this.id = item.id;
      // this.image =
      //   "https://media.sproutsocial.com/uploads/2017/02/10x-featured-social-media-image-size.png";
    },
    changeStatus(item) {
      axios
        .post(apiRoutes.UploadWork.status, {
          status: item.id,
        })
        .then((response) => {
          this.getItems();
          this.loading = false;
        });
    },
    getItems() {
      axios
        .post(apiRoutes.UploadWork.getData, { id: this.$route.params.id })
        .then((response) => {
          this.items = response.data.response;
          this.loading = false;
        });
    },
    getStudentData() {
      axios.post(apiRoutes.UploadWork.getStudentData).then((response) => {
        // this.formalizeTable(response.data);
        this.items = response.data.response;
        this.loading = false;
      });
    },
    uploadImage(work_id, index) {
      
        let formData = new FormData();
        formData.append("work_image", this.form_data.work_file[index]);
        formData.append("file_type", this.form_data.work_file[index].type);
        formData.append("id", work_id);
        axios
        .post(apiRoutes.UploadWork.uploadByTutor , formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.errors = {};
          this.form_data.work_file = {} ;
          bus.$emit("workUpload");
          this.snackbar = true;
          this.snackbarMessage = response.data.message;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });


    }
  },
  created() {
    if (this.$route.params.id) {
      this.getItems();
    } else {
      this.getStudentData();
    }
    bus.$on("workUpload", () => {
      this.getStudentData();
    });

    bus.$on("getAdminNewData", () => {
      this.open = false;
      this.dialog = false;
      this.image = null;
      this.getItems();
    });
    bus.$on("closeDialog", () => {
      this.open = false;
      this.dialog = false;
      this.image = null;
    });
  },
};
</script>

<style scoped>
.pending {
  color: rgb(255, 255, 255);
  background: #ff0000c4 !important;
  font-weight: bold;
}

.checked {
  color: white;
  background: #47ad47 !important;
}
</style>
